export const navLinksdata = [
  {
    _id: 1001,
    title: "Home",
    link: "/",
    cName: "nav-links",
    icon: "fa-solid fa-house",
  },
  {
    _id: 1002,
    title: "Services",
    link: "services",
    cName: "nav-links",
    icon: "fa-solid fa-person-digging",
  },
  {
    _id: 1003,
    title: "Gallery",
    link: "gallery",
    cName: "nav-links",
    icon: "fa-solid fa-images",
  },
  {
    _id: 1004,
    title: "About",
    link: "about",
    cName: "nav-links",
    icon: "fa-solid fa-address-card",
  },
  {
    _id: 1005,
    title: "Reviews",
    link: "reviews",
    cName: "nav-links",
    icon: "fa-solid fa-comments",
  },
  {
    _id: 1006,
    title: "Contact",
    link: "contact",
    cName: "nav-links",
    icon: "fa-solid fa-phone",
  },
];
